import Loading from "../../../components/Loading"
import DistrictGrid from "../../../components/DistrictGrid"

const DistrictsComponent = ({ Districts }: any) => {
    return Districts?.length > 0 ? <div className="pt-5 pb-5 bg-gray-300">
        <DistrictGrid
            object={Districts}
        />
    </div>
        : <Loading />
}
export default DistrictsComponent